export const featuredIssue = {
  issueNumber: 12,
  title: "The Vintage Carhartt Gold Rush: How Resellers Made $2,400 This Week",
  description: "Vintage Carhartt workwear exploded across all platforms this week. We identified the trend 10 days early—here's what to source now and where to sell it for maximum profit.",
  coverImage: "https://public.readdy.ai/ai/img_res/5db3762c0f1546ab96e64a7982e4b7d0.jpg",
  link: "https://theboloreport.substack.com/"
};

export const popularReports = [
  {
    issueNumber: 11,
    title: "Y2K Denim Brands Surging on Poshmark: The $40 to $180 Flip",
    description: "Low-rise jeans from specific brands are selling 3x faster than last month. We break down which labels to hunt for at thrift stores.",
    coverImage: "https://readdy.ai/api/search-image?query=y2k%20low%20rise%20denim%20jeans%20styled%20flat%20lay%20on%20soft%20cream%20background%20minimal%20aesthetic%20clean%20product%20photography%20natural%20light%20editorial%20magazine%20style&width=500&height=650&seq=report011&orientation=portrait",
    link: "https://theboloreport.substack.com/"
  },
  {
    issueNumber: 10,
    title: "Patagonia Fleece: The Consistent Money Maker Every Reseller Needs",
    description: "Why Patagonia fleece remains one of the most reliable flips in the resale game, plus the exact models that sell fastest.",
    coverImage: "https://readdy.ai/api/search-image?query=patagonia%20fleece%20jacket%20folded%20neatly%20on%20minimal%20white%20surface%20clean%20product%20photography%20soft%20shadows%20professional%20editorial%20style%20high%20end%20magazine%20aesthetic&width=500&height=650&seq=report010&orientation=portrait",
    link: "https://theboloreport.substack.com/"
  },
  {
    issueNumber: 9,
    title: "Nike Tech Fleece Tracking: Which Colors Are Moving and Which Aren't",
    description: "Not all Tech Fleece sells the same. We analyzed 847 listings to show you exactly which colorways are worth your time.",
    coverImage: "https://readdy.ai/api/search-image?query=nike%20tech%20fleece%20hoodie%20arranged%20on%20clean%20minimal%20surface%20modern%20product%20photography%20soft%20lighting%20editorial%20magazine%20style%20professional%20high%20quality&width=500&height=650&seq=report009&orientation=portrait",
    link: "https://theboloreport.substack.com/"
  }
];

export const categories = [
  {
    name: "Clothing & Apparel",
    icon: "ri-shirt-line",
    description: "Trending brands and styles in streetwear, vintage, and contemporary fashion"
  },
  {
    name: "Sneakers",
    icon: "ri-footprint-line",
    description: "Market data on limited releases, retro models, and high-demand kicks"
  },
  {
    name: "Vintage",
    icon: "ri-time-line",
    description: "Era-specific trends and valuable vintage pieces across all categories"
  },
  {
    name: "Home Goods",
    icon: "ri-home-4-line",
    description: "Coming soon: Furniture, decor, and collectible home items"
  },
  {
    name: "Electronics",
    icon: "ri-smartphone-line",
    description: "Coming soon: Tech gadgets, gaming, and consumer electronics"
  },
  {
    name: "Emerging Trends",
    icon: "ri-flashlight-line",
    description: "Early signals and micro-trends before they hit the mainstream"
  }
];

export const valueProps = [
  {
    icon: "ri-line-chart-line",
    title: "What's Selling Fast",
    description: "Real marketplace data and trending brands across eBay, Poshmark, Whatnot, and more. Know what's moving before everyone else does."
  },
  {
    icon: "ri-price-tag-3-line",
    title: "What to Pay",
    description: "Clear guidance on sourcing prices so you never overpay. We show you the sweet spot between thrift store finds and profitable flips."
  },
  {
    icon: "ri-store-2-line",
    title: "Where to Sell",
    description: "Which platforms are performing best for specific items. Maximize your profit by selling on the right marketplace every time."
  }
];